module.exports = __webpack_public_path__ + "img/whatsapp.1ec574b5.png";